import React, { createRef, forwardRef, useContext, useEffect, useMemo, useRef, FC, useLayoutEffect, useState, useImperativeHandle, useCallback, ComponentProps } from 'react';
import ReactDOM from 'react-dom';
// import { createCognitiveServicesSpeechServicesPonyfillFactory } from 'botframework-webchat'; //Components
// import createCognitiveServicesSpeechServicesPonyfillFactory from 'botframework-webchat/lib/createCognitiveServicesSpeechServicesPonyfillFactory';
import { Components, ReactWebChatProps } from 'botframework-webchat-component';

import FullComposer, { FullComposerProps } from 'botframework-webchat/lib/FullComposer';

// import Composer from 'botframework-webchat-component/lib/Composer';


// import { Components} from 'botframework-webchat'; //Components

import activityFromBot from 'botframework-webchat-core/src/definitions/activityFromBot';
import { hooks } from 'botframework-webchat-component';
import createStyleSet from 'botframework-webchat/lib/createFullStyleSet';

import TypingAnimation from 'botframework-webchat-component/lib/Assets/TypingAnimation';
import { unstable_batchedUpdates } from 'react-dom';

import { BehaviorSubject } from 'rxjs';

import './WebChat.css';
import DruidWebchatContext, { DruidWebchatContextType } from './WebChatContext';
import { WebChatOptions } from './WebChatOptions';
import DruidSendBox from './components/DruidSendBox';
import { DruidImagesViewer, DruidImageViewHandle } from './components/DruidImagesViewer';

import { useCreateBFStore, useHandleInitialize } from './hooks';
import { useActivityStatusMiddleware, useAtttachmentMiddleware, useCardActionMiddleware, useActivityMiddleware, useScrollToEndButtonMiddleware, useAvatarMiddleware } from './hooks/useDruidBFMiddleswares';
import { useCognitiveServices } from './hooks/useCognitiveServices';
import { useCreateDirectLine } from './hooks/useCreateDirectLine';
import { useSetDirectLineInstance } from './hooks/useSetDirectLineInstance';
import { useStaticDruidStyleSet } from './hooks/useStaticDruidStyleSet';

import { useDebounceHideSuggestedActions } from './hooks/useDebounceHideSuggestedActions';
import normalizeLanguage from 'botframework-webchat-api/lib/utils/normalizeLanguage';




import { useDeterminedDirection } from './selectors/useDeterminedDirection';
import { useMarkdownIt } from './hooks/useMarkdownIt';
import classNames from 'classnames';
import * as merge from 'deepmerge';
import { useDruidAdaptiveCardsHostConfig, useMergedOptions } from './selectors/useMergedOptions';
import useStyleToEmotionObject from 'botframework-webchat-component/lib/hooks/internal/useStyleToEmotionObject';

import 'famfamfam-flags/dist/sprite/famfamfam-flags.min.css';
import { DruidHeader } from './components/header/DruidHeader';
import { DruidIsVoiceInputSelector } from './components/header/DruidIsVoiceInputSelector';
import { DruidLanguageSelector } from './components/header/DruidLanguageSelector';


import { useFocus } from 'botframework-webchat-component/lib/hooks';
import { useWebChatRefsContext } from './hooks/useWebChatRefsContext';
import { ErrorBoundary } from 'react-error-boundary';
import { ErrorFallback } from './components/ErrorFallback';
import useDruidLocalize from './hooks/useDruidLocalize';
const DruidFullComposer: FC<Omit<FullComposerProps, "children"> & ReactWebChatProps> = (props: any) => <FullComposer {...props}></FullComposer>

const { useActivities, useDisabled, useSuggestedActions, useUserID, useStyleSet, useDirection, useLocalizer, useSendPostBack, useSubmitSendBox, 
          useFocusSendBox, usePostActivity, useSendMessage, useSendEvent, useObserveScrollPosition, useCreateScrollToEndButtonRenderer, useScrollToEnd, useScrollTo, useObserveTranscriptFocus } = hooks;
const { BasicWebChat } = Components;
const WebChat = forwardRef(({ className, initialOptions }: { className: string, initialOptions: WebChatOptions }, ref) => {

  const [druidWebChatState, druidWebChatDispatch, getState, druidStyleToEmotionObject] = useContext<DruidWebchatContextType>(DruidWebchatContext);

  const { UI: { buttonsPadding, buttonsBorderRadius, buttonsBorderColor, buttonsBackgroundColor, buttonsBackgroundColorOnHover, buttonsTextColorOnHover, buttonsTextColor, transcriptFontSize, activityStatusShowBotName, activityStatusBotName, activityStatusUserName, activityStatusShowUserName } = {},
    styleOptions: {  suggestedActionTextColor, fontSizeSmall, subtle, paddingRegular } = {}, disabled,
    designPatterns: { nonCarousel_HeroCard_AutoWidth, nonCarousel_HeroCard_ButtonsOnly_BackgroundTransparent } = {},
    localization
  } = useMergedOptions();

  const { store, ...projectedMergedChatOptions } = useMergedOptions();
  const druidAdaptiveCardHostConfig = useDruidAdaptiveCardsHostConfig();

  const directlineInstance = useCreateDirectLine();
  useSetDirectLineInstance({ directlineInstance });

  const { bfStore, subscriptions } = useCreateBFStore({ initialOptions });

  // const markdownIt = useMemo(() => markdownIT({html: true, linkify: true, breaks: true,
  //   typographer: true}), []);

  const [outerBFSuggestedActions, setOuterBFSuggestedActions] = useState<any[]>([]);

  //used to set bfStore inside druid's state. also listens for bfStore's state changes and updates current component internal state (not druid's state).
  useEffect(() => { // should not setstate inside useMemo
    druidWebChatDispatch({
      type: 'SET_BF_WEBCHAT_STORE',
      payload: bfStore
    });
    var previousState: any = null;
    const bfStoreUnsubscribe = bfStore.subscribe(() => {
      const currentState = bfStore.getState();
      if (previousState?.suggestedActions !== currentState.suggestedActions) {
        setOuterBFSuggestedActions(currentState.suggestedActions);
      }

      previousState = currentState;
    });

    return () => {
      bfStoreUnsubscribe();
    }
  }, [bfStore]);
  useEffect(() => { // on component dismount
    return () => {
      subscriptions.forEach((sub) => sub.unsubscribe());
    }
  }, []);

  const markdownIt = useMarkdownIt();

  const cognitiveServices = useCognitiveServices();

  const handleInitializeCallback = useHandleInitialize();
  const determinedDir = useDeterminedDirection();

  const druidImagesViewerRef = useRef<DruidImageViewHandle>(null);
  const debounceHideSuggestedActions = useDebounceHideSuggestedActions(outerBFSuggestedActions);


  projectedMergedChatOptions.activityStatusMiddleware = useActivityStatusMiddleware(projectedMergedChatOptions);
  projectedMergedChatOptions.cardActionMiddleware = useCardActionMiddleware(projectedMergedChatOptions);

  projectedMergedChatOptions.attachmentMiddleware = useAtttachmentMiddleware(druidImagesViewerRef, projectedMergedChatOptions);
  projectedMergedChatOptions.activityMiddleware = useActivityMiddleware(projectedMergedChatOptions);
  projectedMergedChatOptions.scrollToEndButtonMiddleware = useScrollToEndButtonMiddleware(projectedMergedChatOptions, debounceHideSuggestedActions);
  projectedMergedChatOptions.avatarMiddleware = useAvatarMiddleware(projectedMergedChatOptions)
  
  useEffect(() => {
    handleInitializeCallback();
  }, [handleInitializeCallback]);

 const staticDruidStyleSet = useStaticDruidStyleSet({ outerBFSuggestedActions });
 const shouldRenderWebchat = !!druidWebChatState.directlineOptions?.token;
 useImperativeHandle(ref, () => {
    return shouldRenderWebchat;
  }, [shouldRenderWebchat]); //bfStore.dispatch, 

  const druidLocalize = useCallback(
    (strings, language: string) => {
      const normalizedLanguage = normalizeLanguage(language);

      if(localization && localization[normalizedLanguage]) {
        return {
          ...strings,
          ...localization[normalizedLanguage]
          // TEXT_INPUT_PLACEHOLDER: 'What is on your mind?'
        };
      }
     

      return strings;
    },
    [localization],
  );
    
  // should useMemo
 const mergedStyleSet = merge.all([createStyleSet({ ...projectedMergedChatOptions.styleOptions }),
  staticDruidStyleSet,
  projectedMergedChatOptions.customDruidStyleSet || {}
]);


  return (
    <React.Fragment>
      {

        shouldRenderWebchat ? (
          // node_modules\adaptivecards\lib\host-config.js
          // <DruidFullComposer  directLine={directlineInstance} store={bfStore} styleOptions={{scrollToEndButtonBehavior: 'any', autoScrollSnapOnPage: 90}}>
          //     <div>
          //     <CustomDecorator></CustomDecorator>
          //     <BasicWebChat className={`${className || ''}`} > </BasicWebChat>
          //     </div>
          // </DruidFullComposer>
          
          <DruidFullComposer {...projectedMergedChatOptions}
            directLine={directlineInstance}
            store={bfStore}
            styleSet={
              mergedStyleSet
            }
            adaptiveCardsHostConfig={druidAdaptiveCardHostConfig}
            //  sendTypingIndicator={true}
            typingIndicatorMiddleware={() => next => ({ ...args }) => {
              const currentDruidState = getState();
              const { disableTyping } = currentDruidState.mergedChatOptions?.UI || {};
              if(disableTyping || !currentDruidState.showTyping) {
                return;
              }
              return <DotIndicator withText={typeof currentDruidState.showTyping === "string" ? `${currentDruidState.showTyping}`: undefined}/>;
            }}
            renderMarkdown={markdownIt.render.bind(markdownIt)}
            locale={druidWebChatState.locale}
            webSpeechPonyfillFactory={cognitiveServices}
            userID={druidWebChatState.mergedChatOptions.userId}
            username={druidWebChatState.mergedChatOptions.username || druidWebChatState.mergedChatOptions.userId}
            dir={determinedDir}
            overrideLocalizedStrings={druidLocalize}
          // attachmentMiddleware={attachmentMiddleware}
          // activityStatusMiddleware={activityStatusMiddleware}
          // cardActionMiddleware={cardActionMiddleware}
          // scrollToEndButtonMiddleware={() => (next) => (args) => {
          //   //atEnd could be used for suggestedAction hiding
          //   const { atEnd, styleOptions: { scrollToEndButtonBehavior }, unread } = args;
          //   debounceHideSuggestedActions.next(!atEnd);
          //   return next(args);
          // } }
          >
            <ErrorBoundary 
                FallbackComponent={ErrorFallback}
            >
            <CustomDecorator></CustomDecorator>
                <DruidHeader>
                  {{
                    VoiceInputSelector: <DruidIsVoiceInputSelector />,
                    DruidLanguageSelector: <DruidLanguageSelector />
                  }}
                </DruidHeader> 
                <BasicWebChat className={`${className || ''}`}> </BasicWebChat>
                <DruidImagesViewer ref={druidImagesViewerRef} />
                <DruidSendBox />
            </ErrorBoundary>
          </DruidFullComposer>
          
        ) : (
          !druidWebChatState.directlineOptions?.token && <React.Fragment>
            <DruidHeader>
            </DruidHeader>
            <div className={`${className || ''} connect-spinner`} dir={determinedDir}>
              <div className="content">
                <div className="icon">
                  <span className="ms-Icon ms-Icon--Robot" />
                </div>
                {druidWebChatState.INITIALIZATION_STATUS === 'uninitialized' && <p>Please wait while we are connecting.</p>}
                {druidWebChatState.INITIALIZATION_STATUS === 'failed' && <p>Failed to load {druidWebChatState.INITIALIZATION_STATUS_MESSAGE && `(${druidWebChatState.INITIALIZATION_STATUS_MESSAGE})`}. <a href="#!" onClick={(e) => {e.preventDefault(); druidWebChatDispatch({ type: 'RESET' }); }}>Retry</a></p>}
              </div>
            </div>
          </React.Fragment>
        )
      }
    </React.Fragment>
  )
});

const getLastActivity = (messageActivities: any[]) => { // move to helper
  return messageActivities[messageActivities.length - 1];
}

const CustomDecorator = () => {
  const [druidWebChatState,, getState,] = useContext<DruidWebchatContextType>(DruidWebchatContext);
  const { wcRootRef } = useWebChatRefsContext();

  const [activities] = useActivities();
  const [suggestedActions] = useSuggestedActions();
  const scrollToEnd = useScrollToEnd();
  const scrollTo = useScrollTo();
  const sendPostBack = useSendPostBack();
  const postActivity = usePostActivity();
  const sendMessage = useSendMessage();
  const sendEvent = useSendEvent();
  const submitSendBox = useSubmitSendBox();
  const focus = useFocus();

  
  const userId = useUserID();
  const setFocus = useFocus();
  const { INITIALIZATION_STATUS, minimized, mergedChatOptions: { UI: { hideSuggestedActions, restylingsEnabled } = {}}} = druidWebChatState;

  useLayoutEffect(() => {
    if (suggestedActions) {
      wcRootRef?.querySelectorAll('.webchat__suggested-action')?.forEach((sg, idx) => {
        const { channelData: { buttonClass = null } = {} } = suggestedActions[idx] as any;
        buttonClass && sg.classList.add(buttonClass);
      });
    }
  }, [suggestedActions, wcRootRef, hideSuggestedActions]);

  useEffect(() => {
    const currentState = getState();
    if(INITIALIZATION_STATUS === 'success' && !minimized && !currentState.isMobile) { // focus sendbox automatically on chat open
      setFocus('sendBox');
    }
  }, [INITIALIZATION_STATUS, minimized, setFocus]);

  useEffect(() => {
    DruidWebchat_v2.hooks.scrollToEnd = scrollToEnd;
    DruidWebchat_v2.hooks.scrollTo = scrollTo;
    DruidWebchat_v2.hooks.sendPostBack = sendPostBack;
    DruidWebchat_v2.hooks.postActivity = postActivity;
    DruidWebchat_v2.hooks.sendMessage = sendMessage;
    DruidWebchat_v2.hooks.sendEvent = sendEvent;
    DruidWebchat_v2.hooks.submitSendBox = submitSendBox;
    DruidWebchat_v2.hooks.focus = focus;
  }, [scrollToEnd, scrollTo, sendPostBack, postActivity, sendMessage, sendEvent, submitSendBox]);
  useLayoutEffect(() => {
    
    var sendBoxButton = wcRootRef?.querySelector('svg.webchat__send-icon');
    if (sendBoxButton) {
      if(restylingsEnabled) {

//         <svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
// <path d="M12.6875 6.71094C12.5 6.89844 12.25 6.99219 12 6.99219C11.7188 6.99219 11.4688 6.89844 11.2812 6.71094L8 3.42969V12.9922C8 13.5547 7.53125 13.9922 7 13.9922C6.5 13.9922 6 13.5547 6 12.9922V3.42969L2.6875 6.71094C2.3125 7.11719 1.65625 7.11719 1.28125 6.71094C0.875 6.33594 0.875 5.67969 1.28125 5.30469L6.28125 0.304688C6.65625 -0.101562 7.3125 -0.101562 7.6875 0.304688L12.6875 5.30469C13.0938 5.67969 13.0938 6.33594 12.6875 6.71094Z" fill="black"/>
// </svg>
        sendBoxButton.setAttribute('height', '16px');
        sendBoxButton.setAttribute('width', '16px');

        sendBoxButton.setAttribute('viewBox', '0 0 13 14');

        sendBoxButton.querySelector('path')?.setAttribute('d', "M12.6875 6.71094C12.5 6.89844 12.25 6.99219 12 6.99219C11.7188 6.99219 11.4688 6.89844 11.2812 6.71094L8 3.42969V12.9922C8 13.5547 7.53125 13.9922 7 13.9922C6.5 13.9922 6 13.5547 6 12.9922V3.42969L2.6875 6.71094C2.3125 7.11719 1.65625 7.11719 1.28125 6.71094C0.875 6.33594 0.875 5.67969 1.28125 5.30469L6.28125 0.304688C6.65625 -0.101562 7.3125 -0.101562 7.6875 0.304688L12.6875 5.30469C13.0938 5.67969 13.0938 6.33594 12.6875 6.71094Z");
      } else {
        sendBoxButton.setAttribute('viewBox', '0 0 28 28');
        sendBoxButton.querySelector('path')?.setAttribute('d', "M 14 0.4375 C 21.492188 0.4375 27.5625 6.507812 27.5625 14 C 27.5625 21.492188 21.492188 27.5625 14 27.5625 C 6.507812 27.5625 0.4375 21.492188 0.4375 14 C 0.4375 6.507812 6.507812 0.4375 14 0.4375 Z M 12.417969 8.289062 L 16.546875 12.25 L 6.5625 12.25 C 5.835938 12.25 5.25 12.835938 5.25 13.5625 L 5.25 14.4375 C 5.25 15.164062 5.835938 15.75 6.5625 15.75 L 16.546875 15.75 L 12.417969 19.710938 C 11.890625 20.21875 11.878906 21.066406 12.398438 21.585938 L 13 22.179688 C 13.511719 22.695312 14.34375 22.695312 14.851562 22.179688 L 22.109375 14.929688 C 22.625 14.414062 22.625 13.585938 22.109375 13.074219 L 14.851562 5.8125 C 14.339844 5.300781 13.507812 5.300781 13 5.8125 L 12.398438 6.410156 C 11.878906 6.933594 11.890625 7.78125 12.417969 8.289062 Z M 12.417969 8.289062");
      }
    }
  });

  return (null);
}

const DotIndicator = ({ withText }: { withText?: string}) => {
  const [druidWebChatState,,] = useContext<DruidWebchatContextType>(DruidWebchatContext);

  const { disableTypingAnimation } = druidWebChatState.mergedChatOptions?.UI || {};
  const{ styleOptions: { subtle, fontSizeSmall } = {}
  } = useMergedOptions();

  const styleToEmotionObject = useStyleToEmotionObject();
  const [{ typingIndicator: typingIndicatorStyleSet }] = useStyleSet();
  const [direction] = useDirection();
  const localize = useLocalizer();
  const druidLocalize = useDruidLocalize(localize);

  const ROOT_STYLE = {
      '&.webchat__typingIndicator': {
        'fontSize': fontSizeSmall, 
        backgroundSize: 'contain',
        color: subtle,
        '&::first-letter': {
          textTransform: !withText ? 'capitalize': 'none',
        },
        paddingBottom: 5
      },
      
  };

  const TYPING_ANIMATION_STYLE = {
    '& .webchat__typingIndicator': {
      backgroundSize: 'contain',
    },
    '& .webchat__typingIndicator-text': {
        fontWeight: 400,
        background: 'linear-gradient(90deg, #767676, #AFBED3, #767676)',
        backgroundSize: '300% auto',
        color: 'transparent',
        backgroundClip: 'text',
        animation: 'druid-typing-loading 8s ease infinite',
        transitionTimingFunction: 'ease-in-out',
        '&::first-letter': {
          textTransform: withText ? 'capitalize': 'none',
        }
    }
};

  const rootClassName = styleToEmotionObject(ROOT_STYLE) + '';
  const typingAnimationOverridesClassName = styleToEmotionObject(TYPING_ANIMATION_STYLE) + '';
  if(disableTypingAnimation) {
    return (
      <span className={classNames(rootClassName, typingIndicatorStyleSet + '', 'webchat__typingIndicator', direction === 'rtl' && 'webchat__typingIndicator--rtl')}>
        {druidLocalize('DRUID_USER_IS_TYPING', withText || "")}...
      </span>);
  }
  
  return (
    <div className={classNames(typingAnimationOverridesClassName, typingIndicatorStyleSet + '',  direction === 'rtl' && 'webchat__typingIndicator--rtl')}>
       { withText ? <div style={{display: 'flex', alignItems: 'center', color: subtle, fontSize: fontSizeSmall}}><TypingAnimation aria-label={localize('TYPING_INDICATOR_ALT')} /> <div className={'webchat__typingIndicator-text'}>{druidLocalize('DRUID_USER_IS_TYPING', withText)}</div></div>:<TypingAnimation aria-label={localize('TYPING_INDICATOR_ALT')} /> }
    </div>
  );
};

export default WebChat;
